// @ts-nocheck
import { Navigate } from "react-router-dom"
import { SettingsClient } from "@/components/settings/SettingsClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function SettingsPage() {
  const { supabaseUser } = useAuth()
  if (!supabaseUser) return <Navigate to="/auth/login" replace />
  return <div className="container-narrow py-4"><SettingsClient userId={supabaseUser.id} /></div>
}